import $ from 'jquery'

const stickyNav = $('.bm-sticky-nav')

if (stickyNav.length) {
  const headings = $('.main-content h2')
  if (headings.length) {
    const list = stickyNav.find('ul')
    headings.map((index, heading) => {
      if (heading) {
        heading.id = `sticky-nav-${index}`
        list.append(
          `<li><a href="#sticky-nav-${index}">${heading.innerText}</a></li>`
        )
      }
    })
  }
}
